<div class="title">
    <h1>{{ title }}</h1>
</div>
